/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classnames from 'classnames';
import { MessageProperties } from '../../../../types';
import gridTogglerStyles from './gridToggler.module.pcss';
import BiggerImagesMobileIcon from '../../../../../../svg/icons/grid-toggler-bigger-mobile.svg';
import BiggerImagesIcon from '../../../../../../svg/icons/grid-toggler-bigger.svg';
import SmallerImagesMobileIcon from '../../../../../../svg/icons/grid-toggler-more-mobile.svg';
import SmallerImagesIcon from '../../../../../../svg/icons/grid-toggler-more.svg';

interface GridTogglerProps {
  messages: MessageProperties;
  isDisabled: boolean;
  isBiggerImagesSelected: boolean;
  gridTogglerHandler: () => void;
}

function GridToggler({
  messages,
  isBiggerImagesSelected,
  isDisabled,
  gridTogglerHandler
}: GridTogglerProps): React.ReactElement {
  const styles = { ...gridTogglerStyles };

  return (
    <div className={styles['grid-toggler']}>
      <p className={styles['grid-toggler__title']}>{messages.title}</p>
      <label className={styles['grid-toggler__button']}>
        <input
          type="checkbox"
          disabled={isDisabled}
          onClick={gridTogglerHandler}
          defaultChecked={isBiggerImagesSelected}
        />
        <span className={styles['grid-toggler__slider']} />
        <SmallerImagesIcon
          className={classnames(styles['grid-toggler__icon--desktop'], styles['grid-toggler__icon--left'])}
        />
        <SmallerImagesMobileIcon
          className={classnames(styles['grid-toggler__icon--mobile'], styles['grid-toggler__icon--left'])}
        />
        <BiggerImagesIcon
          className={classnames(styles['grid-toggler__icon--desktop'], styles['grid-toggler__icon--right'])}
        />
        <BiggerImagesMobileIcon
          className={classnames(styles['grid-toggler__icon--mobile'], styles['grid-toggler__icon--right'])}
        />
      </label>
    </div>
  );
}

export default GridToggler;
